import React, { useEffect, useState } from "react";
import Table from "../../../../core/pagination/datatable";
import { Link } from "react-router-dom";
import { Select, Spin, Modal, Input } from "antd";
import { Edit } from "feather-icons-react/build/IconComponents";
import { Trash } from "react-feather";
import { getApiBaseUrl, LOGIN, ADD_ACTIVITY } from "../../Config/Config";
import Swal from "sweetalert2";

const InspectionCheckList = () => {
  const columns = [
    {
      title: "Checklist Name",
      dataIndex: "ChecklistName",
    },
    {
      title: "Stage Name",
      dataIndex: "StageName",
    },
    {
      title: "Description",
      dataIndex: "Description",
    },
    {
      title: "Actions",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              data-bs-toggle="offcanvas"
              data-bs-target="#EditCheckListTypeOffcanvas"
              aria-controls="EditCheckListTypeOffcanvas"
              onClick={() => handleEditClick(record)}
            >
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="me-2 p-2"
              onClick={() => handleDeleteClick(record)}
            >
              <Trash className="feather-trash" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [addForm, setAddForm] = useState({
    ChecklistName: "",
    Description: "",
  });
  const [addLoading, setAddLoading] = useState(false);
  const [selectedStageId, setSelectedStageId] = useState(null);

  const [editForm, setEditForm] = useState({
    Id: null,
    ChecklistName: "",
    Description: "",
    StagesOrderId: null,
  });
  const [saving, setSaving] = useState(false);

  const [stagesOptions, setStagesOptions] = useState([]);
  const [stageLoading, setStageLoading] = useState(false);

  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  const [askPasswordAdd, setAskPasswordAdd] = useState(false);
  const [passwordAdd, setPasswordAdd] = useState("");
  const [showPasswordAdd, setShowPasswordAdd] = useState(false);
  const [errorAdd, setErrorAdd] = useState("");

  const [askPasswordEdit, setAskPasswordEdit] = useState(false);
  const [passwordEdit, setPasswordEdit] = useState("");
  const [showPasswordEdit, setShowPasswordEdit] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");

  const [reauthVisible, setReauthVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState(null);

  const logActivity = async (isSuccess, notes) => {
    try {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: notes,
          Location: "InspectionChecklist",
          IsSucces: isSuccess ? 1 : 0,
        }),
      });
    } catch (err) {
      console.error("Failed to log activity:", err);
    }
  };

  const fetchChecklist = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/getChecklist`);
      const json = await res.json();
      if (json.Status) {
        setData(json.ResultData);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchStages = async () => {
    setStageLoading(true);
    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/getstages`);
      const json = await res.json();
      if (json.Status) {
        const options = json.ResultData.map((item) => ({
          label: item.StageName,
          value: item.Id,
        }));
        setStagesOptions(options);
      } else {
        setStagesOptions([]);
      }
    } catch (err) {
      console.error("Failed to fetch stages:", err);
      setStagesOptions([]);
    } finally {
      setStageLoading(false);
    }
  };

  useEffect(() => {
    fetchChecklist();
    fetchStages();
  }, []);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setAddForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddSubmit = (e) => {
    e.preventDefault();

    if (!selectedStageId) {
      Swal.fire({
        icon: "warning",
        title: "Stage Required",
        text: "Please select a stage before submitting",
      });
      return;
    }

    if (!addForm.ChecklistName.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Checklist Name Required",
        text: "Please enter Checklist Name",
      });
      return;
    }

    setAskPasswordAdd(true);
    setErrorAdd("");
  };

  const handleAuthAdd = async () => {
    if (!passwordAdd.trim()) {
      setErrorAdd("Please enter your password.");
      return;
    }

    setAddLoading(true);
    setErrorAdd("");

    try {
      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user?.UserName,
          password: passwordAdd,
        }),
      });

      const data = await res.json();

      if (data.status) {
        setAskPasswordAdd(false);
        setPasswordAdd("");
        await performAdd();
      } else {
        setErrorAdd(data.Message || "Invalid credentials. Please try again.");
      }
    } catch (err) {
      setErrorAdd("Unable to authenticate. Please try again.");
    } finally {
      setAddLoading(false);
    }
  };

  const performAdd = async () => {
    const payload = {
      ChecklistName: addForm.ChecklistName,
      Description: addForm.Description,
      StagesOrderId: selectedStageId,
      CreatedBy: user.UserID,
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/addChecklist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const json = await res.json();

      if (json?.Status) {
        await logActivity(
          true,
          `Checklist "${addForm.ChecklistName}" created successfully`,
        );
        Swal.fire("Success", "Checklist added successfully!", "success").then(
          () => {
            setAddForm({ ChecklistName: "", Description: "" });
            setSelectedStageId(null);
            document.getElementById("closeOffCanvas")?.click();
            fetchChecklist();
          },
        );
      } else {
        await logActivity(
          false,
          `Checklist "${addForm.ChecklistName}" creation failed`,
        );
        Swal.fire("Failed", json?.Message || "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Error adding checklist:", error);
      await logActivity(
        false,
        `Checklist "${addForm.ChecklistName}" creation failed`,
      );
      Swal.fire("Failed", "Failed to connect to server.", "error");
    }
  };

  const handleEditClick = (record) => {
    setEditForm({
      Id: record.Id,
      ChecklistName: record.ChecklistName,
      Description: record.Description,
      StagesOrderId: record.StagesOrderId,
    });
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    if (!editForm.ChecklistName.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Checklist Name Required",
        text: "Please enter Checklist Name",
      });
      return;
    }

    setAskPasswordEdit(true);
    setErrorEdit("");
  };

  const handleAuthEdit = async () => {
    if (!passwordEdit.trim()) {
      setErrorEdit("Please enter your password.");
      return;
    }

    setSaving(true);
    setErrorEdit("");

    try {
      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user?.UserName,
          password: passwordEdit,
        }),
      });

      const data = await res.json();

      if (data.status) {
        setAskPasswordEdit(false);
        setPasswordEdit("");
        await performEdit();
      } else {
        setErrorEdit(data.Message || "Invalid credentials. Please try again.");
      }
    } catch (err) {
      setErrorEdit("Unable to authenticate. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const performEdit = async () => {
    const payload = {
      Id: editForm.Id,
      ChecklistName: editForm.ChecklistName,
      Description: editForm.Description,
      StagesOrderId: Number(editForm.StagesOrderId),
      UpdatedBy: user.UserID,
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/updateChecklist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const json = await res.json();

      if (json?.Status) {
        await logActivity(
          true,
          `Checklist "${editForm.ChecklistName}" updated successfully`,
        );

        setData((prev) =>
          prev.map((row) =>
            row.Id === editForm.Id
              ? {
                  ...row,
                  ChecklistName: payload.ChecklistName,
                  Description: payload.Description,
                  StagesOrderId: payload.StagesOrderId,
                }
              : row,
          ),
        );

        Swal.fire("Success", "Checklist updated successfully!", "success").then(
          () => {
            document.getElementById("editOffcanvasClose")?.click();
            fetchChecklist();
            setEditForm({
              Id: null,
              ChecklistName: "",
              Description: "",
              StagesOrderId: null,
            });
          },
        );
      } else {
        await logActivity(
          false,
          `Checklist "${editForm.ChecklistName}" update failed`,
        );
        Swal.fire("Failed", json?.Message || "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Error updating checklist:", error);
      await logActivity(
        false,
        `Checklist "${editForm.ChecklistName}" update failed`,
      );
      Swal.fire("Failed", "Failed to connect to server.", "error");
    }
  };

  // const handleDelete = async (record) => {
  //   const payload = {
  //     Id: record.Id,
  //     UpdatedBy: user.UserID,
  //   };

  //   const result = await Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you really want to delete this checklist?",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   });

  //   if (!result.isConfirmed) return;

  //   try {
  //     Swal.fire({
  //       title: "Deleting...",
  //       text: "Please wait",
  //       allowOutsideClick: false,
  //       didOpen: () => Swal.showLoading(),
  //     });

  //     const res = await fetch(`${getApiBaseUrl()}/Checklist/deleteChecklist`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     const json = await res.json();

  //     if (json?.Status) {
  //       await Swal.fire({
  //         icon: "success",
  //         title: "Deleted!",
  //         text: "Checklist deleted successfully",
  //         timer: 1500,
  //         showConfirmButton: false,
  //       });
  //       fetchChecklist();
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Delete Failed",
  //         text: json?.Message || "Unable to delete checklist",
  //       });
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text: "Something went wrong. Please try again later.",
  //     });
  //   }
  // };
  const handleDeleteClick = (record) => {
    setRecordToDelete(record);
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this checklist?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setPassword("");
        setPasswordError("");
        setReauthVisible(true);
      }
    });
  };

  const handlePasswordSubmit = async () => {
    if (!password.trim()) {
      setPasswordError("Please enter your password");
      return;
    }

    setDeleteLoading(true);
    setPasswordError("");

    try {
      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: user?.UserName,
          password,
        }),
      });

      const data = await res.json();

      if (data.status) {
        // Success → perform delete
        await performDelete(recordToDelete);
        setReauthVisible(false);
        setPassword("");
      } else {
        setPasswordError(data.Message || "Invalid password. Please try again.");
      }
    } catch (err) {
      setPasswordError("Failed to authenticate. Please check your connection.");
      console.error(err);
    } finally {
      setDeleteLoading(false);
    }
  };

  const performDelete = async (record) => {
    const payload = {
      Id: record.Id,
      UpdatedBy: user.UserID,
    };

    try {
      const res = await fetch(`${getApiBaseUrl()}/Checklist/deleteChecklist`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const json = await res.json();

      if (json?.Status) {
        await logActivity(
          true,
          `Checklist "${record.ChecklistName}" deleted successfully`,
        );
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Checklist deleted successfully",
          timer: 1500,
          showConfirmButton: false,
        });
        fetchChecklist();
      } else {
        await logActivity(
          false,
          `Failed to delete Checklist "${record.ChecklistName}"`,
        );
        Swal.fire({
          icon: "error",
          title: "Delete Failed",
          text: json?.Message || "Unable to delete checklist",
        });
      }
    } catch (error) {
      console.error(error);
      await logActivity(
        false,
        `Error deleting Checklist "${record.ChecklistName}"`,
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong. Please try again later.",
      });
    }
  };
  return (
    <>
      {(saving || addLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Inspection checklist types
                  </h4>
                </ol>
              </nav>
              <h6>Manage Checklist types</h6>
            </div>
            <div className="page-btn">
              <Link
                data-bs-toggle="offcanvas"
                data-bs-target="#AddCheckListTypeOffcanvas"
                aria-controls="AddCheckListTypeOffcanvas"
                className="btn btn-success btn-sm"
              >
                <i className="ti ti-circle-plus fs-4"></i>
              </Link>
            </div>
          </div>

          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set mt-4"></div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : data?.length > 0 ? (
                  <Table columns={columns} dataSource={data} rowKey="Id" />
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ── Add Offcanvas with re-auth ── */}
        <div>
          <style>{`
            @media (max-width: 576px) {
              #AddCheckListTypeOffcanvas { width: 90% !important; }
            }
            @media (min-width: 577px) and (max-width: 992px) {
              #AddCheckListTypeOffcanvas { width: 55% !important; }
            }
            @media (min-width: 993px) and (max-width: 1440px) {
              #AddCheckListTypeOffcanvas { width: 25% !important; }
            }
            @media (min-width: 1441px) {
              #AddCheckListTypeOffcanvas { width: 20% !important; }
            }
          `}</style>

          <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="AddCheckListTypeOffcanvas"
            aria-labelledby="AddCheckListTypeOffcanvasLabel"
          >
            <form onSubmit={handleAddSubmit}>
              <div className="offcanvas-header">
                <h5 id="AddCheckListTypeOffcanvasLabel">Add Checklist Type</h5>
                <div className="d-flex align-items-center ms-auto">
                  <button
                    type="submit"
                    className="btn btn-sm btn-outline-success me-2"
                    title="Save"
                  >
                    <i className="fa fa-check fs-4"></i>
                  </button>
                  <button
                    id="closeOffCanvas"
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </div>
              </div>

              <div className="offcanvas-body">
                <div className="mb-3">
                  <label className="form-label">Stage Name  <span className="text-danger ms-1">*</span></label>
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Select Stage"
                    options={stagesOptions}
                    loading={stageLoading}
                    value={selectedStageId}
                    onChange={(value) => setSelectedStageId(value)}
                    allowClear
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="assetType" className="form-label">
                    Checklist Name
                  </label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="text"
                    className="form-control"
                    name="ChecklistName"
                    placeholder="Enter Checklist Name"
                    value={addForm.ChecklistName}
                    onChange={handleFormChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="note" className="form-label">
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    name="Description"
                    placeholder="Enter Description"
                    value={addForm.Description}
                    onChange={handleFormChange}
                    rows={3}
           
                  ></textarea>
                </div>

                {askPasswordAdd && (
                  <div className="mt-2">
                    <div className="mb-3 w-lg-75 m-auto">
                      <label className="form-label">
                        Confirm Password <span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={showPasswordAdd ? "text" : "password"}
                          name="password"
                          className="pass-input form-control"
                          value={passwordAdd}
                          onChange={(e) => {
                            setPasswordAdd(e.target.value);
                            setErrorAdd("");
                          }}
                          onCopy={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          onCut={(e) => e.preventDefault()}
                          placeholder="Enter Password"
                        />
                        <span
                          className={`ti toggle-password ${
                            showPasswordAdd ? "ti-eye" : "ti-eye-off"
                          }`}
                          onClick={() => setShowPasswordAdd(!showPasswordAdd)}
                        ></span>
                      </div>
                    </div>

                    {errorAdd && (
                      <div className="alert alert-danger" role="alert">
                        {errorAdd}
                      </div>
                    )}

                    <button
                      type="button"
                      className="btn btn-primary btn-sm me-2"
                      onClick={handleAuthAdd}
                      disabled={addLoading || !passwordAdd.trim()}
                    >
                      {addLoading ? "Verifying..." : "Confirm"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        setAskPasswordAdd(false);
                        setPasswordAdd("");
                        setErrorAdd("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>

        <div>
          <style>{`
            @media (max-width: 576px) {
              #EditCheckListTypeOffcanvas { width: 90% !important; }
            }
            @media (min-width: 577px) and (max-width: 992px) {
              #EditCheckListTypeOffcanvas { width: 55% !important; }
            }
            @media (min-width: 993px) and (max-width: 1440px) {
              #EditCheckListTypeOffcanvas { width: 25% !important; }
            }
            @media (min-width: 1441px) {
              #EditCheckListTypeOffcanvas { width: 20% !important; }
            }
          `}</style>

          <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="EditCheckListTypeOffcanvas"
            aria-labelledby="EditCheckListTypeOffcanvasLabel"
          >
            <form onSubmit={handleEditSubmit}>
              <div className="offcanvas-header">
                <h5 id="EditCheckListTypeOffcanvasLabel">
                  Edit Checklist Type
                </h5>
                <div className="d-flex align-items-center ms-auto">
                  <button
                    type="submit"
                    className="btn btn-sm btn-outline-success me-2"
                    title="Update"
                    disabled={saving}
                  >
                    <i className="fa fa-check fs-4"></i>
                  </button>
                  <button
                    id="editOffcanvasClose"
                    type="button"
                    className="btn-close text-reset"
                    data-bs-dismiss="offcanvas"
                  ></button>
                </div>
              </div>

              <div className="offcanvas-body">
                <div className="mb-3">
                  <label className="form-label">Stage Name</label>
                  <Select
                    style={{ width: "100%" }}
                    placeholder="Select Stage"
                    options={stagesOptions}
                    loading={stageLoading}
                    value={Number(editForm.StagesOrderId)}
                    onChange={(value) =>
                      setEditForm((prev) => ({
                        ...prev,
                        StagesOrderId: value,
                      }))
                    }
                    allowClear
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Checklist Name</label>
                  <span className="text-danger ms-1">*</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Checklist name"
                    value={editForm.ChecklistName}
                    onChange={(e) =>
                      setEditForm({
                        ...editForm,
                        ChecklistName: e.target.value,
                      })
                    }
                    required
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    placeholder="Enter Description"
                    value={editForm.Description}
                    onChange={(e) =>
                      setEditForm({ ...editForm, Description: e.target.value })
                    }
                    required
                  ></textarea>
                </div>

                {/* Password confirmation – same as NewFilterType */}
                {askPasswordEdit && (
                  <div className="mt-2">
                    <div className="mb-3 w-lg-75 m-auto">
                      <label className="form-label">
                        Confirm Password <span className="text-danger"> *</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={showPasswordEdit ? "text" : "password"}
                          name="password"
                          className="pass-input form-control"
                          value={passwordEdit}
                          onChange={(e) => {
                            setPasswordEdit(e.target.value);
                            setErrorEdit("");
                          }}
                          onCopy={(e) => e.preventDefault()}
                          onPaste={(e) => e.preventDefault()}
                          onCut={(e) => e.preventDefault()}
                          placeholder="Enter Password"
                        />
                        <span
                          className={`ti toggle-password ${
                            showPasswordEdit ? "ti-eye" : "ti-eye-off"
                          }`}
                          onClick={() => setShowPasswordEdit(!showPasswordEdit)}
                        ></span>
                      </div>
                    </div>

                    {errorEdit && (
                      <div className="alert alert-danger" role="alert">
                        {errorEdit}
                      </div>
                    )}

                    <button
                      type="button"
                      className="btn btn-primary btn-sm me-2"
                      onClick={handleAuthEdit}
                      disabled={saving || !passwordEdit.trim()}
                    >
                      {saving ? "Verifying..." : "Confirm"}
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        setAskPasswordEdit(false);
                        setPasswordEdit("");
                        setErrorEdit("");
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>

        <Modal
          title="Confirm Password"
          open={reauthVisible}
          onOk={handlePasswordSubmit}
          onCancel={() => {
            setReauthVisible(false);
            setPassword("");
            setPasswordError("");
          }}
          confirmLoading={deleteLoading}
          okText="Confirm "
          cancelText="Cancel"
          width={350}
          okButtonProps={{
      
            disabled: deleteLoading || !password.trim(),
          }}
        >
          <Spin spinning={deleteLoading}>
            <div className="mt-3">
              <Input.Password
                placeholder="Enter your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError("");
                }}
                autoComplete="new-password"
                onCopy={(e) => e.preventDefault()}
                onPaste={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                onPressEnter={handlePasswordSubmit}
              />
              {passwordError && (
                <div className="text-primary mt-2">{passwordError}</div>
              )}
            </div>
          </Spin>
        </Modal>
      </div>
    </>
  );
};

export default InspectionCheckList;
